export const findProductByNameQueryKey = (name: string) => ['product', name];
